import * as React from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Button, Stack, styled, Typography } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { AppReg } from "../../assets/Svg";
import { toast } from "react-toastify";
import {
  deletePayments,
  deleteSpecificPaymentFromClient,
  deleteSupplierPayments,
  getClientById,
  loginAdmin,
} from "../../apiservices";
import { CustomToolbar } from "../categories/categoryTable";
import EditIcon from "@mui/icons-material/Edit";
import CustomDialogue from "../reuseableComp/Modal";
import { Typo } from "../bank";

const Btn = styled(Button)({
  textTransform: "none",
  background: "#EEF4FF",
  color: "#008890",
  "&:hover": {
    color: "#FFF",
    background: "#008890",
  },
});

export default function DataTable({
  editPayment,
  view,
  viewLedger,
  data,
  getData,
  handleCheck,
  clientData,
}) {
  const [state, setState] = React.useState({
  password: "",
  isDelete: false
});
  const columns = [
    { field: "date", headerName: "Date" },
    { field: "show_id", headerName: "Payment#", width: 130 },
    { field: "supplier_name", headerName: "Supplier", width: 200 },
    {
      field: "transaction_mode",
      headerName: "Transaction Mode",
      sortable: true,
      width: 150,
    },
    { field: "amount", headerName: "Amount", width: 150, valueFormatter: (params) => `Rs ${params.value}` },
    {
      field: "actions",
      headerName: "Actions",
      width: 200,
      sortable: false,
      renderCell: (params) => (
        <>
          <Btn
            sx={{ height: '30px', width: '150px', mr: '5px', padding: 0 }}
            variant="contained"
            color="primary"
            size="small"
            onClick={() => view(params.row)}>
            View Payment
          </Btn>
          <Btn
            title="Edit"
            variant="contained"
            sx={{ width: '30px', height: '30px', minWidth: '30px', mr: '5px', padding: 0, background: "#eed202", color: "white" }}
            onClick={() => edit(params.row)}>
            <EditIcon fontSize="small" />
          </Btn>
          <Btn
            title="Delete"
            sx={{ width: '30px', height: '30px', minWidth: '30px', mr: '5px', padding: 0, background: "red", color: "white" }}
            variant="contained"
            onClick={() => deleteRow(params.row)}>
            <DeleteIcon fontSize="small" />
          </Btn>
          {/* You can add more buttons or customize based on your requirements */}
        </>
      ),
    }
  ];

  const rows = data ? data : [];
  const edit = (params) => {
    editPayment(params);
    // handleCheck();
  };
  const deleteRow = async (params) => {
    setState((prev) => ({
      ...prev,
      isDelete: true,
      id: params.id,
    }));
  };
  return (
    <div style={{ height: "80vh", width: "100%" }}>
      <DataGrid
        rows={rows}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 20 },
          },
        }}
        pageSizeOptions={[20, 50, 100]}
        components={{
          Toolbar: CustomToolbar,
        }}
      />
      <CustomDialogue
      open={state.isDelete}
      handleClose={() => { }}
      header={
        <Stack justifyContent={"center"} alignItems={"center"}>
          <Typo>Deletion</Typo>
        </Stack>
      }
      content={
        <>
          <Stack sx={{ padding: 1 }}>
            <Stack sx={{ mt: 2 }}>
              <Typography>Please enter password if you really want to delete <strong>{`Payment#"${state.id}"`}</strong>.</Typography>
              <input onChange={(e) => {
                setState((prev) => ({
                  ...prev,
                  password: e.target.value,
                }));
              }} type="password" />
            </Stack>
          </Stack>
          <div style={{ float: "right" }}>
            <Btn
              sx={{ height: '30px', mt: '10px', mr: '5px', padding: 0, background: "red", color: "white" }}
              variant="contained"
              size="small"
              onClick={async () => {
                let userData = JSON.parse(localStorage.getItem("user"));
                let credentials = {
                  username: userData.username,
                  password: state.password,
                };
                let resUser = await loginAdmin(credentials);
                if (resUser.success) {
                  let res = await deleteSupplierPayments(state.id);
                  if (res.success) {
                    toast.success("Payment deleted successfully");
                    getData();
                    setState((prev) => ({
                      ...prev,
                      isDelete: false,
                    }));
                  }
                }
                else {
                  toast.error("Wrong password...!")
                }
              }}
            >Delete</Btn>
            <Btn
              sx={{ height: '30px', mt: '10px', mr: '5px', padding: 0 }}
              variant="contained"
              color="error"
              size="small"
              onClick={() => {
                setState((prev) => ({
                  ...prev,
                  isDelete: false,
                }));
              }}
            >Close</Btn>
          </div>
        </>
      }
    />
    </div>
  );
}
